import style from './style.css';

const Header = () => (
  <header class={style.header}>
    <h1>did you ____ today?</h1>
  </header>
);

export default Header;
